import { useTheme, useMediaQuery } from '@mui/material';
import i18n from '../components/common/i18n';
import {
  getEnv, IOS_STORE_LINK, PLAYSTORE_APP_LINK, PLAYSTORE_APP_LINK_ID, PLAYSTORE_APP_LINK_PLI,
} from '../api/env';

const fillRegexp = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

const ANDROID_STORE_URL = `${getEnv(PLAYSTORE_APP_LINK)}
?id=${getEnv(PLAYSTORE_APP_LINK_ID)}
&pli=${getEnv(PLAYSTORE_APP_LINK_PLI)}`;

const IOS_STORE_URL = getEnv(IOS_STORE_LINK);

export const fillMessageWith = (message, ...args) => {
  const values = args.reduce((acc, v, i) => {
    acc[i.toString()] = v;
    return acc;
  }, {});
  return message.replace(fillRegexp, (exp, prop) => (values[prop] !== undefined ? values[prop] : ''));
};

export const translateErrorOrDefault = (errorCode, defaultMessage) => {
  const errorMessage = errorCode ? i18n[errorCode] : undefined;
  return errorMessage !== undefined ? errorMessage
    : (defaultMessage !== undefined ? defaultMessage
      : 'Ocurrio un error!');
};

export const generateLinkWithFileInResponse = (res) => {
  const blob = new Blob([res], { type: 'application/pdf', encoding: 'UTF-8' });
  const link = document.createElement('a');
  link.setAttribute('href', window.URL.createObjectURL(blob));
  link.setAttribute('target', '_blank');
  link.click();
};

export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};

export const getMobileOperatingSystem = () => {
  const userAgent = window.navigator.userAgent || window.window.opera || window.navigator.vendor;

  if (/windows phone/i.test(userAgent)) {
    return 'windows_phone';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  return 'desktop';
};

export const isMobileOperatingSystem = () => {
  const os = getMobileOperatingSystem();
  return os === 'android' || os === 'ios' || os === 'windows_phone';
};

export const redirectToStore = () => {
  const os = getMobileOperatingSystem();

  if (os === 'android') {
    window.open(ANDROID_STORE_URL, '_blank');
    return;
  }

  if (os === 'ios') {
    window.open(IOS_STORE_URL, '_blank');
    return;
  }

  console.log('Redirect to store: dispositivo no mobile');
};
